import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { Box, ButtonLink, Stack, TextAlpha, useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { generateTestId } from '../../../util/TestUtil';
const TEST_ID = 'pdp-compare-empty-page';
const CompareEmptyPage = () => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { root } = useAemConfig();
    const isMobile = useMediaQueryMatchesOnMobile();
    return (_jsx(Box, { paddingBlock: { base: '14', md: '32' }, testId: TEST_ID, children: _jsxs(Stack, { direction: "col", justify: "around", align: !isMobile ? 'center' : 'start', gap: "4", children: [_jsx(TextAlpha, { variant: "bodyL", testId: generateTestId({ testId: TEST_ID, suffix: 'hint' }), children: t('compare.empty.nothing.added') }), _jsx(ButtonLink, { href: `${root}lister.html`, testId: generateTestId({ testId: TEST_ID, suffix: 'btn' }), children: t('compare.empty.add.products') })] }) }));
};
export { CompareEmptyPage };
